import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import "./index.css";
import "@/lib/i18n";
import { ApiError } from "@/api/problem";
import { createAppRouter } from "@/app/router";
import { meQuery } from "@/features/auth/session";

const queryClient: QueryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
  mutationCache: new MutationCache({
    onError: (error) => {
      // A trial can end while the app is open, and the first change refused is how the app
      // learns of it. Reloading `/me` brings up the read-only banner in the shell.
      if (error instanceof ApiError && error.isReadOnly) {
        void queryClient.invalidateQueries({ queryKey: meQuery.queryKey });
      }
    },
  }),
});

// The router reads the session through this client in its guards, so it needs the same instance.
const router = createAppRouter(queryClient);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
